<script>
import api from '@/helpers/api-rest/api.js';

export default {
  props: {
    showProductionModal: Boolean,
    production: {type: Object, default: () => {
        return {
            name: '',
            address: '',
            postal_code: '',
            cnae: '',
            latitude: '',
            longitude: '',
            installed_potency: '',
            unit_potency: '',
            elements_quantity: '',
            park: '',
            selectedCompanyType: '',
            selectCommunities: '',
            selectProvinces: '',
            selectMunicipalities: '',
            autonomous_community_id: '',
            province_id: ''
        }
    }} 
  },
  data() {
    return {
      selectOptionsCompanyType: [],
      selectedCommunities: [],
      selectedProvinces: [],
      selectedMunicipalities: [],
    };
  },
  computed: {
    modalTitle() {
      return this.production?.id ? 'Editar Productora' : 'Añadir Productora';
    },
    submitButtonText() {
        return this.production?.id ? 'Guardar' : 'Añadir Productora';
    }
  },
  created() {
    this.loadSelectOptions();
    this.loadSelectCommunities();
    this.loadSelectProvinces(this.production.autonomous_community_id);
    this.loadSelectMunicipality(this.production.province_id);
  },
  methods: {
    onCommunityChange() {
      const selectedCommunityId = this.production.autonomous_community_id;
      this.loadSelectProvinces(selectedCommunityId);
    },
    onProvinceChange() {
      const selectedProvinceId = this.production.province_id;
      this.loadSelectMunicipality(selectedProvinceId);
    },
    loadSelectOptions() {
      const apiEndpoint = `/api/v1/company-types`;
      api.get({url:apiEndpoint})
        .then(response => {
          this.selectOptionsCompanyType = response.data;
        })
        .catch(error => {
          console.error("Error al cargar los tipos de compañias:", error);
        });
    },
    loadSelectCommunities() {
      const apiEndpoint = `/api/v1/autonomous_communities`;
      api.get({url:apiEndpoint, params:{
        'status': 1
      }})
        .then(response => {
          this.selectedCommunities = response.data;
        })
        .catch(error => {
          console.error("Error al cargar las comunidades:", error);
        });
    },
    loadSelectProvinces(selectedCommunityId) {
      const apiEndpoint = `/api/v1/provinces`;
      api.get({url:apiEndpoint, params:{
        'status': 1,
        'autonomous_community_id': selectedCommunityId
      }})
        .then(response => {
          //console.log(response);
          this.selectedProvinces = response.data;
        })
        .catch(error => {
          console.error("Error al cargar las provincias:", error);
        });
    },
    loadSelectMunicipality(selectedProvinceId) {
      const apiEndpoint = `/api/v1/municipalities`;
      api.get({url:apiEndpoint, params:{
        'status': 1,
        'province_id': selectedProvinceId
      }})
        .then(response => {
          //console.log(response);
          this.selectedMunicipalities = response.data;
        })
        .catch(error => {
          console.error("Error al cargar las localidades:", error);
        });
    },
    createProduction() {
      //const apiHost = process.env.VUE_APP_API_HOST;
      const apiEndpoint = `/api/v1/production-companies`; 
      api.post({url:apiEndpoint, data:this.production})
      //axios.post(apiEndpoint, this.consumer)
        .then(response => {
          const newProduction = response.data;
          this.$emit('success', newProduction);
          this.$bvModal.hide("ModalProduction");
        })
        .catch(error => {
          console.error("Error al crear la productora:", error);
        });
    },

    updateProduction() {
        const apiEndpoint = `/api/v1/production-companies`;
        api.put({url:apiEndpoint, data:this.production, id:this.production.id})
        .then(response => {
            const updatedProduction = response.data;
            this.$emit('success', updatedProduction);
            this.$bvModal.hide("ModalProduction");
        })
        .catch(error => {
            console.error("Error editando productora:", error);
        });
    },

    submitForm() {        
        if(this.production?.id){
            return this.updateProduction();
        }

        return this.createProduction();
    },
    cancelForm() {
        this.$bvModal.hide("ModalProduction");
        this.$emit('close-modal');
    }
  }
};
</script>


<template>
  
  <b-modal id="ModalProduction" :title="modalTitle" :size="'xl'">
    <template #default="{  }">
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12 mb-2">
            <div class="card">
              <div class="card-header text-white bg-primary">Información general</div>
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="name">Nombre:</label>
                      <input v-model="production.name" type="text" class="form-control" id="name" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="address">Dirección:</label>
                      <input v-model="production.address" type="text" class="form-control" id="address" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="postal_code">Código postal:</label>
                      <input v-model="production.postal_code" type="text" class="form-control" id="postal_code" required>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="cnae">CNAE:</label>
                      <input v-model="production.cnae" type="text" class="form-control" id="cnae" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                    <label for="selectedCompanyType">Tipo de compañía:</label>
                    <select v-model="production.company_type_id" class="form-control" id="selectedCompanyType">
                      <option v-for="option in selectOptionsCompanyType" :value="option.id" :key="option.id">{{ option.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="park">Parque:</label>
                      <input v-model="production.park" type="text" class="form-control" id="park" required>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="installed_potency">Potencia instalada:</label>
                      <input v-model="production.installed_potency" type="text" class="form-control" id="installed_potency" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="unit_potency">Unidad de potencia:</label>
                      <input v-model="production.unit_potency" type="text" class="form-control" id="unit_potency" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="elements_quantity">Elementos:</label>
                      <input v-model="production.elements_quantity" type="text" class="form-control" id="elements_quantity" required>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12 mb-2">
            <div class="card">
              <div class="card-header text-white bg-primary">Localización</div>
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                    <label for="selectCommunities">Selecciona una comunidad:</label>
                    <select v-model="production.autonomous_community_id" @change="onCommunityChange" class="form-control" id="selectCommunities">
                      <option v-for="option in selectedCommunities" :value="option.id" :key="option.id">{{ option.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                    <label for="selectProvinces">Selecciona una provincia:</label>
                    <select v-model="production.province_id" @change="onProvinceChange" class="form-control" id="selectProvinces" :disabled="!production.autonomous_community_id">
                      <option v-for="option in selectedProvinces" :value="option.id" :key="option.id">{{ option.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                    <label for="selectMunicipalities">Selecciona una localidad:</label>
                    <select v-model="production.municipality_id" class="form-control" id="selectMunicipalities" :disabled="!production.province_id">
                      <option v-for="option in selectedMunicipalities" :value="option.id" :key="option.id">{{ option.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="latitude">Latitud:</label>
                      <input v-model="production.latitude" type="text" class="form-control" id="latitude" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="longitude">Longitud:</label>
                      <input v-model="production.longitude" type="text" class="form-control" id="longitude" required>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>

    <template #modal-footer="{  }">
      <b-button variant="primary" @click="submitForm()">{{ submitButtonText }}</b-button>
      <b-button @click="cancelForm()">Cancel</b-button>
    </template>
  </b-modal>
</template>